import React, { KeyboardEvent } from "react";
// Define props Card can accept
export interface CardProps {
  title: string;
  description?: string;
  imageUrl?: string;
  onClick?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
}

const Card: React.FC<CardProps> = ({
  title,
  description,
  imageUrl,
  onClick,
  disabled = false,
  children,
  className = "",
  size = "md",
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (disabled || !onClick) {
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  const isInteractive = Boolean(onClick) && !disabled;
  const cardClass = `card card--${size} ${disabled ? "card--disabled" : ""} ${className}`;

  return (
    <div
      className={cardClass}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={isInteractive ? "button" : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      aria-disabled={disabled || undefined}
      aria-label={title || undefined}
    >
      {/* Optional image */}
      {imageUrl && !imageUrl.includes(".mp4") && (
        <img src={imageUrl} alt={title} className="card-image" loading="lazy" decoding="async" />
      )}
      {imageUrl && imageUrl.includes(".mp4") && (
        <video autoPlay loop muted playsInline preload="metadata" className="card-video">
          <source src={imageUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}

      {/* Optional title */}
      {/* Remove if GridCard handles title elsewhere */}
      {/* <h3 className="text-[clamp(24px,4vw,48px)] text-center font-semibold mb-2">
        {title}
      </h3> */}

      {/* Optional description */}
      {description && <p className="text-white mb-2">{description}</p>}

      {/* Children (usually GridCard content) */}
      {children}
    </div>
  );
};

export default Card;
